import React from "react";

const TextInfoStep4 = ({ text, hoverText, isOptional, containerClassNames, textClassNames }) => {
   return (
      <div className={containerClassNames}>
         <label className={textClassNames}>
            {text}
            {isOptional && <span className="optional"> {" "} (obligatoriu)</span>}
         </label>
         <span data-hover={hoverText} className="hovertext ms-2">
            <img alt="" src={require("assets/images/info.png")} />
         </span>
      </div>
   );
};

export default TextInfoStep4;
